module.exports = {"360481001":"湓城街道","360481002":"桂林街道","360481100":"码头镇","360481101":"白杨镇","360481102":"南义镇","360481103":"横港镇","360481104":"范镇","360481105":"肇陈镇","360481106":"高丰镇","360481107":"夏畈镇","360481200":"乐园乡","360481201":"洪一乡","360481202":"花园乡","360481203":"洪下乡","360481204":"武蛟乡","360481205":"横立山乡","360481206":"黄金乡","360481207":"南阳乡","360481500":"赛湖农场","360481501":"青山林场","360481502":"瑞昌市大德山林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360481.json
// module id = 1178
// module chunks = 0